import { Dispatch, SetStateAction, useCallback } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useSelectDefaultAllDaysOfWeek = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
) => {
  return useCallback(
    (daysOfWeek: DayOfWeekType[], index: number, type: StockUnionType | '') => {
      const setState = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!setState) return
      setState((prevState) => {
        prevState[index].days_of_week = [...daysOfWeek]
        return [...prevState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useSelectDefaultAllDaysOfWeek
